import React from 'react';
import {
  GlobeAltIcon,
  ShieldCheckIcon,
  ChartBarIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

const About = () => {
  const features = [
    {
      icon: ShieldCheckIcon,
      title: 'Secure Trading',
      description:
        'Enterprise-grade security with multi-signature wallets and real-time monitoring.',
    },
    {
      icon: ChartBarIcon,
      title: 'Real-time Analytics',
      description:
        'Advanced charts and market data to help you make informed trading decisions.',
    },
    {
      icon: UserGroupIcon,
      title: 'Expert Support',
      description:
        '24/7 customer support from our dedicated team of trading professionals.',
    },
    {
      icon: GlobeAltIcon,
      title: 'Global Access',
      description:
        'Trade from anywhere in the world with our accessible platform.',
    },
  ];

  return (
    <div className="dashboard-page fade-in">
      <div className="dashboard-head">
        <h1 className="dashboard-page-title about-page-title">About Coinspire</h1>
        <p className="about-page-subtitle">
          Coinspire is a next-generation crypto trading platform designed for both beginners and experienced traders.
        </p>
      </div>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Our Vision</h2>
        </div>
        <div className="dashboard-section-body">
          <div className="about-content-card">
            <p className="about-content-text">
              We believe in democratizing access to professional trading tools. Our platform combines
              powerful analytics with an intuitive interface, making crypto trading accessible to everyone
              while maintaining institutional-grade security.
            </p>
          </div>
        </div>
      </section>

      <section className="about-feature-grid">
        {features.map((feature, index) => (
          <div key={index} className="about-feature-card">
            <div className="about-feature-icon">
              <feature.icon className="h-5 w-5 text-blue-400" />
            </div>
            <h3 className="about-feature-title">{feature.title}</h3>
            <p className="about-feature-text">{feature.description}</p>
          </div>
        ))}
      </section>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Founded with Purpose</h2>
        </div>
        <div className="dashboard-section-body">
          <div className="about-content-card">
            <p className="about-content-text">
              Coinspire was founded by a team of experienced traders and blockchain engineers
              dedicated to creating a transparent, secure, and user-friendly trading environment.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;